// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__7DE-d","row":"Node_row__1W8uh","label":"Node_label__1wVOe","footer":"Node_footer__1Xm5q"};